import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import Card from "../../../components/Card";
import {
  settings,
  SlickWrap,
  StorySliderWraaper,
  StorySliderStyle,
} from "../../Home/components/styled";
import { GetBlogPosts } from "../../../api/blog";

const StorySlider = (props) => {
  const [post_list, update_post_list] = useState(0);

  useEffect(() => {
    GetBlogPosts({
      paged: 1,
      postsPerPage: 12,
      series: 4949,
    })
      .then((res) => {
        console.log(res);
        if (res.data.code == 200) {
          update_post_list(res.data.body.items);
        } else {
          update_post_list(null);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);
  return (
    <StorySliderWraaper type="1">
      <StorySliderStyle>
        {post_list ? (
          <SlickWrap>
            <Slider {...settings}>
              {post_list
                ? post_list.map((post, key) => (
                    <Card isBlog={1} item={post} width="100%" />
                  ))
                : "로딩"}
            </Slider>
          </SlickWrap>
        ) : (
          ""
        )}
      </StorySliderStyle>
    </StorySliderWraaper>
  );
};

export default StorySlider;
